import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { FacilityCard } from "@/components/FacilityCard";
import { AppointmentCTA } from "@/components/AppointmentCTA";
import { SITE } from "@/config/site";
import { FACILITIES } from "@/data/facilities";

export default function Facilities() {
  return (
    <>
      <Seo
        title={`Facilities — ${SITE.name}`}
        siteName={SITE.name}
        description={`Facilities at ${SITE.name}, Kasdol — consultation rooms, waiting area, diagnostic and pharmacy support in a clean clinical environment.`}
      />
      <PageHeader
        title="Our Facilities"
        description="Facility details below are demo content and will be updated to reflect the hospital's actual facilities."
        crumbs={[{ label: "Facilities" }]}
      />
      <section className="py-16 sm:py-20" data-testid="facilities-list-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
            {FACILITIES.map((f) => <FacilityCard key={f.slug} facility={f} />)}
          </div>
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
